import * as React from 'react';
import MuiAvatar from '@mui/material/Avatar';
import MuiListItemAvatar from '@mui/material/ListItemAvatar';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import Select, { selectClasses } from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import SmartphoneRoundedIcon from '@mui/icons-material/SmartphoneRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';

const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  color: (theme.vars || theme).palette.text.secondary,
  border: `1px solid ${(theme.vars || theme).palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

export default function SelectUser
() {
  const [company, setCompany] = React.useState('');

  const handleChange = (event) => {
    setCompany(event.target.value);
  };

  return (
    <Select
      labelId="company-select"
      id="company-simple-select"
      value={company}
      onChange={handleChange}
      displayEmpty
      inputProps={{ 'aria-label': 'Select company' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: 215,
        '&.MuiList-root': {
          p: '8px',
        },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          pl: 1,
        },
      }}
    >
      <MenuItem value="">
        <ListItemAvatar>
          <Avatar
            sizes="small"
            alt="All"
            src="/static/images/avatar/7.jpg"
            sx={{ width: 36, height: 36 }}
          />
        </ListItemAvatar>
        <ListItemText primary="All" />
      </MenuItem>
      <ListSubheader sx={{ pt: 0, mt: 1 }}>Workers</ListSubheader>
      <MenuItem value="">
        <ListItemAvatar>
          <Avatar
            sizes="small"
            alt="Ricsi"
            src="/static/images/avatar/7.jpg"
            sx={{ width: 36, height: 36 }}
          />
        </ListItemAvatar>
        <ListItemText primary="Ricsi" />
      </MenuItem>
      <MenuItem value={10}>
        <ListItemAvatar>
          <Avatar
            sizes="small"
            alt="User 2"
            src="/static/images/avatar/6.jpg"
            sx={{ width: 36, height: 36 }}
          />
        </ListItemAvatar>
        <ListItemText primary="USER 2" />
      </MenuItem>
      
      <Divider sx={{ mx: -1 }} />
      <MenuItem value={40}>
        <ListItemIcon>
          <AddRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Add worker" />
      </MenuItem>
    </Select>
  );
}
